import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  CardTitle,
  CardSubtitle,
  Modal,
  ModalBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility'
import { post, get, put } from "../../helpers/api_helper";
import { AvField, AvForm } from "availity-reactstrap-validation";
import DataTable from 'react-data-table-component';

import avatar from "../../assets/images/companies/img-4.png"
// actions
import { createCompany, companySuccess, companyError, updateCompany } from "../../store/actions";
import { profileSuccess, getProfile } from '../../store/auth/profile/actions';
import Loader from "../../components/Loader";
import AddBook from '../Forms/AddBook';
import { toast } from 'react-toastify'
const { io } = require("socket.io-client");

const Booking = props => {
  const { user, company } = props;
  const [loading, setLoading] = useState(false);
  const [socket, setSocket] = useState(null);
  const [data, setData] = useState([]);
  const [bookingColumn, setBookingColumn] = useState([]);
  const [isAddBook, setIsAddBook] = useState(false);
  const [currentSlot, setCurrentSlot] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isReschedule, setIsReschedule] = useState(false);
  const [isToday, setIsToday] = useState(true);
  const [isRevisitBook, setIsRevisitBook] = useState(false);
  const [revisitData, setRevisitData] = useState([]);

  useEffect(() => {
    const socket = io(`${Utils.baseURL}/booking`, { transports: ["polling"], upgrade: true });
    // const socket = io("https://192.168.1.1203:8085/booking", { transports: ["websocket"], upgrade: true });
    socket.on("get", (res) => {
      console.log('socket on list', res);
      if (res?.statusCode == 200) {
        // console.log(res?.data);
        res?.data?.map((item) => {
          item.popover = false;
        })
        setData(res?.data);
      }
    });
    socket.on("connect", (socket2) => {
      let date = new Date().getFullYear() + "-" + String(new Date().getMonth() + 1).padStart(2, "0") + "-" + String(new Date().getDate()).padStart(2, "0");
      console.log('socket connected', date);
      setSelectedDate(date);
    });
    socket.on('book', res => {
      console.log('hitting book event of socket', res?.statusCode);
      if (res?.statusCode == 200) {
        console.log('hitting book event of socket', res?.message);
        if (!toast.isActive('booking'))
          toast.success(res?.message, { toastId: 'booking' });
        setIsAddBook(false);
        setIsReschedule(false);
        setIsRevisitBook(false);
      } else
        console.log('hitting book event of socket', res?.error);
      if (!toast.isActive('booking'))
        toast.error(res?.error?.message ? res?.error?.message : res?.error, { toastId: 'booking' });
    })
    setSocket(socket);
  }, [user]);

  useEffect(() => {
    if (selectedDate && user && socket) {
      socket.emit("list", { auth: user?.token, date: selectedDate });
    }
    if (selectedDate && selectedDate == new Date().getFullYear() + "-" + String(new Date().getMonth() + 1).padStart(2, "0") + "-" + String(new Date().getDate()).padStart(2, "0"))
      setIsToday(true);
    else {
      setIsToday(false);
    }
  }, [selectedDate, user]);

  useEffect(() => {
    setBookingColumn([
      {
        name: 'Name',
        selector: row => row?.name,
      },
      {
        name: 'Mobile',
        selector: row => row?.mobile,
      },
      {
        name: 'Slot',
        selector: row => { return row?.slot[0]?.startAt + "-" + row.slot[0]?.endAt },
      },
      {
        cell: (row) => <>
          <AvForm style={{}}>
            <div style={{}}>
              <AvField onChange={(e) => handleUpdateBookingStatus(e.target.value, row)} style={{ minWidth: 150, padding: 5, paddingLeft: 8, paddingRight: 8 }}
                type="select"
                name="book_status"
                placeholder={"Select Status"}
                value={row?.status ? "Accepted" : "Rejected"}
              >
                <option value={"Accepted"}>Accepted</option>
                <option value={"Rejected"}>Rejected</option>
              </AvField>
            </div>
          </AvForm>
          {/* <Button onClick={() => handleDeleteUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button> */}
        </>,
        name: 'Status',
        ignoreRowClick: true,
      }
    ]);
  }, [data]);

  useEffect(() => {
    if (!isAddBook && !isReschedule && !isRevisitBook)
      setCurrentSlot(null);
    setRevisitData([]);
  }, [isAddBook, isReschedule, isRevisitBook]);

  const handleUpdateBookingStatus = (val, item) => {
    console.log('updating status of booking', val, item);
    let body = {
      booking_id: item?.bookings[0]?._id,
      status: val,
      auth: user?.token,
      date: selectedDate,
    }
    socket.emit("update", body, (response) => {
      console.log('update emit response', response); // ok
    });
  }

  const handleBookingResch = (item) => {
    console.log('item to reschdule', item);
    setCurrentSlot(item);
    setIsReschedule(true);
  }

  const handlePopoverToggle = (index) => {
    let temp = Object.assign([], data);
    // console.log(temp[index]?.popover);
    temp[index].popover = temp[index]?.popover ? false : true;
    setData(temp);
    // console.log('item',temp[index]?.popover);
  }

  const handleValidReschedule = (e, value) => {
    let body = {
      ...value,
      booking_id: currentSlot?.bookings[0]?._id,
      auth: user?.token,
      date: selectedDate,
    }
    console.log('submitting reschedule', body);
    socket.emit("update", body, (response) => {
      console.log('update emit response', response); // ok
    });
    setIsReschedule(false);
  }

  const handleMobileChange = (tel) => {
    console.log('tel on change');
    if (tel.length == 10) {
      console.log('mobile is good to go');
      post('/user/check_revisit', { mobile: tel, token: user?.token })
        .then(res => {
          console.log('response from checking mobile', res);
          const unique = [...new Set(res?.data.map(item => item.name))];
          setRevisitData([{ ...res.data[0], name: unique }]);
          console.log('unique names', { ...res.data[0], name: unique });
        })
    } else {
      setRevisitData([]);
    }
  }

  const handleValidRevisit = (e, v) => {
    console.log('current slot ', currentSlot, revisitData);
    const body = {
      ...v,
      address: revisitData[0]?.address,
      gender: revisitData[0]?.gender,
      token: user?.token,
      slotId: currentSlot?._id,
      date: selectedDate
    };
    console.log('revisiting', body);
    socket.emit('add', body);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        {/* +" "+new Date().getHours() + ":"+new Date().getMinutes() + " "+new Date().getHours()>11 ? "pm" : "am" */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem={new Date().toDateString()} />
        <AvForm
          className="form-horizontal"
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className="form-group mb-4">
              <AvField
                name="selectedDate"
                // label={"Date of Booking"}
                value={selectedDate}
                className="form-control"
                type="date"
                max={new Date().getFullYear() + "-" + String(new Date().getMonth() + 1).padStart(2, "0") + "-" + String(new Date().getDate() + 1).padStart(2, "0")}
                onChange={(e) => {
                  console.log('date changed', e.target.value);
                  setSelectedDate(e.target.value);
                }}
              />
            </div>
            {isToday &&
              <Button type="button" style={{ background: `linear-gradient(135deg, ${Utils.themeColor} 0%, #8b0000 100%)`, height: 40, border: 'none' }} onClick={() => setIsAddBook(true)} >Instant Booking</Button>
            }
          </div>
        </AvForm>
        {/* <Lead
          user={user}        
        /> */}
        <Card>
          <CardBody>
            <Row>
              {data?.map((item, index) => {
                if (item?.bookings?.length > 0) {
                  const booking = item?.bookings[0];
                  const isAccepted = booking?.status == 'Accepted';
                  const cardBg = isAccepted
                    ? (item?.startAt
                      ? `linear-gradient(135deg, ${Utils.blueColor} 0%, #0570be 100%)`
                      : `linear-gradient(135deg, ${Utils.themeColor} 0%, #990000 100%)`)
                    : `linear-gradient(135deg, ${Utils.greenColor} 0%, #008a1c 100%)`;

                  return (
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-3" key={index}>
                      <Card
                        className="booking-card"
                        style={{ background: cardBg }}
                      >
                        <div>
                          <div className="booking-card-header">
                            <span className="booking-time-badge">
                              <i className="mdi mdi-clock-check-outline" style={{ fontSize: 15 }} />
                              <span>{item?.startAt ? `${item?.startAt} - ${item?.endAt}` : "Instant Booking"}</span>
                            </span>

                            {isAccepted ? (
                              <Dropdown
                                isOpen={item?.popover}
                                toggle={() => handlePopoverToggle(index)}
                              >
                                <DropdownToggle className="booking-menu-toggle" caret>
                                  <i className="mdi mdi-dots-vertical" style={{ fontSize: 18 }} />
                                </DropdownToggle>
                                <DropdownMenu right className="dropdown-menu-end dropmenu_list">
                                  <DropdownItem onClick={() => handleUpdateBookingStatus('Completed', item)}>
                                    <i className="mdi mdi-check-circle-outline text-success me-2" />
                                    Mark as done
                                  </DropdownItem>
                                  <DropdownItem divider style={{ margin: '4px 0' }} />
                                  <DropdownItem onClick={() => handleUpdateBookingStatus('Rejected', item)}>
                                    <i className="mdi mdi-close-circle-outline text-danger me-2" />
                                    Rejected
                                  </DropdownItem>
                                  {item?._id && (
                                    <>
                                      <DropdownItem divider style={{ margin: '4px 0' }} />
                                      <DropdownItem onClick={() => handleBookingResch(item)}>
                                        <i className="mdi mdi-calendar-clock text-primary me-2" />
                                        Reschedule
                                      </DropdownItem>
                                    </>
                                  )}
                                </DropdownMenu>
                              </Dropdown>
                            ) : (
                              <span
                                className="booking-time-badge"
                                style={{ padding: '2px 8px', fontSize: 11 }}
                              >
                                <i className="mdi mdi-check-all" />
                                <span>Done</span>
                              </span>
                            )}
                          </div>

                          <div className="booking-info-list">
                            <div className="booking-info-row" style={{ alignItems: 'center' }}>
                              <i className="mdi mdi-account booking-info-icon" />
                              <span style={{ fontWeight: 700, fontSize: 14.5, wordBreak: 'break-word' }}>
                                {booking?.name}
                              </span>
                              {booking?.gender && (
                                <span className="booking-gender-pill">
                                  <i className={`mdi ${booking?.gender == 'Male' ? "mdi-gender-male" : "mdi-gender-female"}`} />
                                  <span>{booking?.gender}</span>
                                </span>
                              )}
                            </div>

                            <div className="booking-info-row">
                              <i className="mdi mdi-cellphone-basic booking-info-icon" />
                              <span style={{ fontWeight: 600, letterSpacing: '0.3px' }}>
                                {booking?.mobile || '—'}
                              </span>
                            </div>

                            {booking?.address && (
                              <div className="booking-info-row">
                                <i className="mdi mdi-map-marker-outline booking-info-icon" />
                                <span
                                  title={booking?.address}
                                  style={{
                                    opacity: 0.95,
                                    fontSize: 13,
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden'
                                  }}
                                >
                                  {booking?.address}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </Card>
                    </Col>
                  )
                } else {
                  return (
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-3" key={index}>
                      <Card className="booking-slot-empty">
                        <div className="d-flex align-items-center" style={{ paddingBottom: 10, borderBottom: '1px solid #f1f5f9' }}>
                          <span
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 6,
                              backgroundColor: '#f0f7ff',
                              color: '#0990ec',
                              padding: '4px 10px',
                              borderRadius: 20,
                              fontSize: 12.5,
                              fontWeight: 600
                            }}
                          >
                            <i className="mdi mdi-clock-check-outline" style={{ fontSize: 15 }} />
                            <span>{item?.startAt} - {item?.endAt}</span>
                          </span>
                          <span style={{ marginLeft: 'auto', fontSize: 11.5, fontWeight: 600, color: item?.status ? '#94a3b8' : '#10b981' }}>
                            {item?.status ? 'Unavailable' : 'Available'}
                          </span>
                        </div>

                        <div className="d-flex align-items-center gap-2 mt-3">
                          <Button
                            disabled={item?.status}
                            title={'Book'}
                            type="button"
                            onClick={() => { setIsAddBook(true); setCurrentSlot(item) }}
                            style={{
                              border: 'none',
                              background: item?.status ? "#94a3b8" : `linear-gradient(135deg, ${Utils.blueColor} 0%, #0568b0 100%)`,
                              flex: 1,
                              fontWeight: 600,
                              borderRadius: 8,
                              padding: '7px 14px'
                            }}
                          >
                            Book Slot
                          </Button>
                          <Button
                            disabled={item?.status}
                            title={'Revisit'}
                            type="button"
                            onClick={() => { setIsRevisitBook(true); setCurrentSlot(item) }}
                            style={{
                              border: 'none',
                              background: item?.status ? "#94a3b8" : `linear-gradient(135deg, ${Utils.blueColor} 0%, #0568b0 100%)`,
                              borderRadius: 8,
                              padding: '7px 12px'
                            }}
                          >
                            <img src={require("../../assets/images/revisit.png")} alt="Revisit" style={{ height: 'auto', width: 18 }} />
                          </Button>
                        </div>
                      </Card>
                    </Col>
                  )
                }
              })}
            </Row>
          </CardBody>
        </Card>
        {isAddBook &&
          <Modal isOpen={isAddBook} toggle={() => setIsAddBook(false)} centered={true}>
            <ModalBody className="py-3 px-5">
              <AddBook
                role={'Booking'}
                currentSlot={currentSlot}
                close={() => setIsAddBook(false)}
                user={user}
                socket={socket}
                setLoading={setLoading}
                selectedDate={selectedDate}
              />
            </ModalBody>
          </Modal>
        }
        {isRevisitBook &&
          <Modal isOpen={isRevisitBook} toggle={() => setIsRevisitBook(false)} centered={true}>
            <ModalBody className="py-3 px-5">
              <div className='d-flex justify-content-between align-items-center'>
                <CardTitle style={{ fontWeight: 'bold', color: 'black' }}>Revisit Booking</CardTitle>
                <Button type="button" style={{ background: `linear-gradient(135deg, ${Utils.themeColor} 0%, #8b0000 100%)`, border: 'none' }} onClick={() => setIsRevisitBook(false)}>Close</Button>
              </div>
              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => {
                  handleValidRevisit(e, v)
                }}
              >
                <div style={{ textAlign: 'center', marginTop: 20 }}>
                  <div className="form-group mb-4" style={{ textAlign: 'left' }}>
                    <AvField
                      name="mobile"
                      label={"Mobile Number"}
                      value={data?.mobile}
                      className="form-control"
                      placeholder={`Enter Mobile e.i (9876543210)`}
                      type="number"
                      required
                      validate={{ maxLength: { value: 10 }, minLength: { value: 10 } }}
                      onChange={(e) => handleMobileChange(e.target.value)}
                    />
                  </div>
                  {revisitData?.length > 0 &&
                    <div>
                      <div className="form-group mb-4" style={{ textAlign: 'left' }}>
                        <AvField
                          name="name"
                          label={"Select Patient"}
                          className="form-control"
                          type="select"
                          required
                        >
                          <option value={""}>Select Patient</option>
                          {revisitData[0]?.name?.map((item) => {
                            return (
                              <option value={item}>{item}</option>
                            )
                          })}
                        </AvField>
                      </div>
                      <Button type="submit" style={{ background: `linear-gradient(135deg, ${Utils.themeColor} 0%, #8b0000 100%)`, border: 'none', height: 40 }}>Book</Button>
                    </div>
                  }
                </div>
              </AvForm>
            </ModalBody>
          </Modal>
        }
        {isReschedule &&
          <Modal isOpen={isReschedule} toggle={() => setIsReschedule(false)} centered={true}>
            <ModalBody className="py-3 px-5">
              <div className='d-flex justify-content-between align-items-center'>
                <CardTitle style={{ fontWeight: 'bold', color: 'black' }}>Reschedule Booking</CardTitle>
                <Button type="button" style={{ background: `linear-gradient(135deg, ${Utils.themeColor} 0%, #8b0000 100%)`, border: 'none' }} onClick={() => setIsReschedule(false)}>Close</Button>
              </div>
              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => {
                  handleValidReschedule(e, v)
                }}
              >
                <div style={{ textAlign: 'center', marginTop: 20 }}>
                  <div className="form-group mb-4" style={{ textAlign: 'left' }}>
                    <AvField
                      name="slotId"
                      label={"Select Slot"}
                      className="form-control"
                      type="select"
                      required
                    >
                      <option value={""}>Select Slot</option>
                      {data?.map((item) => {
                        if (!item?.status && item?.bookings?.length < 1)
                          return (
                            <option value={item?._id}>{item?.startAt} - {item?.endAt}</option>
                          )
                      })}
                    </AvField>
                  </div>
                  <Button type="submit" style={{ background: `linear-gradient(135deg, ${Utils.themeColor} 0%, #8b0000 100%)`, border: 'none', height: 40 }}>Reschedule Booking</Button>
                </div>
              </AvForm>
            </ModalBody>
          </Modal>
        }
      </div >
    </React.Fragment >
  )
}

Booking.propTypes = {
  getProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  companyError: PropTypes.func,
  companySuccess: PropTypes.func,
  createCompany: PropTypes.func,
  updateCompany: PropTypes.func
}

const mapStatetoProps = state => {
  const { user } = state.Profile;
  return { user }
}

export default withRouter(
  connect(mapStatetoProps, { createCompany, companySuccess, companyError, getProfile, updateCompany })(Booking)
)
